import usePulseEstimationResult from './usePulseEstimationResult'
import type { EstimationValues } from './usePulseEstimationResult'
import { PulseResultBox, PulseResultRow, PulseResultValue } from './styled-components'

const PulseEstimationResult = (values: EstimationValues) => {
  const { rows } = usePulseEstimationResult(values)

  return (
    <PulseResultBox>
      {rows.map(row => (
        <PulseResultRow key={row.key}>
          <span>{row.label}</span>
          <PulseResultValue>{row.value}</PulseResultValue>
        </PulseResultRow>
      ))}
    </PulseResultBox>
  )
}

export default PulseEstimationResult
